import React from 'react'
import './EarnM.scss';
import EarnImage from '../../../../assets/EarnImage.png';

export default function EarnM() {
  return (
    <div className='earn-container'>
      <div className='left-section'>
        <h1>Earn M Coins by Watching Ads</h1>
        <p>
          Earn free coins just by watching short video ads. These coins can be used across our platform to unlock powerful PDF tools. It’s the easiest way to boost your balance—no purchases required.
        </p>
      </div>
      <div className='right-section'>
        <img src={EarnImage} alt="earn coins" />
      </div>
    </div>
  )
}
